import { iEnvConfig } from '../envConfigs/iEnvConfig.interface';

// These values are expected to be available to both the client and the server
// No Security INFO to be captured here.
export const baseCfg = new (class implements iEnvConfig {
  // NOTE: Package JSON holds a version number tied to Mobile and Apple releases, and is also keyed to Code freeze date.
  // Update package version number accordingly.
  // NOTE please refer to https://semver.org/ on Versioning standards
  // A normal version number MUST take the form X.Y.Z where X, Y, and Z are non-negative integers,
  // and MUST NOT contain leading zeroes. X is the major version, Y is the minor version, and Z is the patch version.
  // Each element MUST increase numerically. For instance: 1.9.0 -> 1.10.0 -> 1.11.0.
  // Major version zero (0.y.z) is for initial development. Anything may change at any time, no fixed public interface expected.

  APP_VERSION = '14.8.5'; // Adhere to Semver - allows communication to fellow developers on the state of the public interface.
  GOOGLE_API_KEY = 'AIzaSyDjItdzeXpS_zGK2nUX0BkHX7QwbhszD74';
  SVR_PFIX = '/api';
  STORE_ID_FIELDNAME = 'ORG_ID';
  SEED_VERSION = '12.0.0';
  production = false;

  // NOTE: variables used with the self reference "this" must be defined before usage
  API_SVR = (() => {
    return `${this.SVR_PFIX}/:${this.STORE_ID_FIELDNAME}`;
  })();
  STORE_ID_PLACEHOLDER = (() => {
    return `<%${this.STORE_ID_FIELDNAME}%>`;
  })();
  API_UI = (() => {
    return `${this.SVR_PFIX}/${this.STORE_ID_PLACEHOLDER}`;
  })();
})();
